import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function MaskedLines({ lines, as: Tag = "h2", className = "", delay = 0, stagger = 0.14, inView = false }) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <motion.span
          key={i}
          className="block overflow-hidden pb-[0.1em] -mb-[0.1em]"
          initial="hidden"
          animate={inView ? undefined : "visible"}
          whileInView={inView ? "visible" : undefined}
          viewport={inView ? { once: true, amount: 0.3 } : undefined}
        >
          <motion.span
            className="block origin-left will-change-transform"
            variants={{
              hidden: { y: "112%", rotate: 2.5 },
              visible: {
                y: "0%",
                rotate: 0,
                transition: { duration: 1.1, ease: EASE, delay: inView ? i * stagger : delay + i * stagger },
              },
            }}
          >
            {line.content}
          </motion.span>
        </motion.span>
      ))}
    </Tag>
  );
}

export function FadeUp({ children, delay = 0, y = 30, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <p className={`font-mono text-[11px] uppercase tracking-[0.3em] text-[#E5C158]/90 flex items-center gap-3 ${className}`}>
      <span className="w-8 h-px bg-[#D4AF37]/60 shrink-0" />
      {children}
    </p>
  );
}

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.3 });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
};